export default __webpack_public_path__ + "static/media/chakra-ui.0c5b3878.svg";